import React, { useEffect, useCallback } from "react";
import { useAppDispatch, useAppSelector } from "../../redux/hooks";
import Loading from "../Loading";
import {
    getSubscriptionStatus,
    initializeSubscription,
} from "./subscriptionActions";
import { SUBSCRIPTION_STATUS } from "../../constants";

type InitializeGuardProps = {
    children: React.ReactNode;
};

const InitializeGuard = ({ children }: InitializeGuardProps) => {
    const dispatch = useAppDispatch();
    const lastInitializedAccountId = React.useRef<string | undefined>();
    const accountId = useAppSelector(
        ({ userData }) => userData.selectedAccount?.accountId
    );
    const { isInitialized, isLoading } = useAppSelector(
        ({ subscriptionData }) => subscriptionData
    );

    const initialize = useCallback(async () => {
        if (!accountId) return;

        try {
            const statusResult = await getSubscriptionStatus(accountId, dispatch);

            if (statusResult.status === SUBSCRIPTION_STATUS.NOT_INITIALIZED) {
                await initializeSubscription(accountId, dispatch);
            }
        } catch (error) {
            console.error("InitializeGuard: initialization failed:", error);
        }
    }, [accountId, dispatch]);

    useEffect(() => {
        if (!accountId) return;
        if (lastInitializedAccountId.current === accountId) return;

        lastInitializedAccountId.current = accountId;
        initialize();
    }, [accountId, initialize]);

    if (isLoading && !isInitialized) {
        return <Loading plain={false} size="large" />;
    }

    return <>{children}</>;
};

export default InitializeGuard;
